import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    border: '1px solid #BCBCBC',
    width: '100%',
    borderRadius: 10,
    marginBottom: 24,
  },
  askContainer: {
    textAlign: 'center',
  },
  askLink: {
    fontSize: 16,
    textDecoration: 'underline',
    color: (props) => (props.error ? '#bcbcbc' : '#6A148E'),
    cursor: (props) => (props.error ? 'auto' : 'pointer'),
  },
  title: {
    fontSize: (props) => (props.mobile ? 20 : 26),
    fontWeight: 500,
  },
  grid: {
    textAlign: 'center',
    margin: '26px 0px',
    '&.MuiGrid-spacing-xs-3': {
      width: '100%',
    },
  },
  button: {
    width: 200,
    height: 40,
  },
  itemInput: {
    minWidth: 300,
  },
  message: {
    width: '57%',
    textAlign: 'left',
    fontSize: 16,
  },
}));

export default useStyles;
